import React from 'react';
import { Box } from 'components';
import { ShippingInfo } from 'apps/shared';
import { OrderPriceBreakdown } from './OrderPriceBreakdown';
import { PaymentInfo } from './PaymentInfo';

interface OrderDetailsProps {
  // TODO: add type for order
  order: any;
}

export const OrderDetails = ({ order }: OrderDetailsProps) => {
  const payment = order.payments[0];

  return (
    <Box mt={8} sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <OrderPriceBreakdown order={order} />
      <PaymentInfo payment={payment} />
      <ShippingInfo address={order.shippingDetail.address} />
    </Box>
  );
};
